import React from 'react'
import { useState, useEffect } from "react";

import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer';
import { STUDENT_USER_TYPE } from '../../services/UserService';
import { StudentNavItems } from './StudentNavItems';
import StudentSelectTestPage from '../../Components/Test/StudentTest/StudentSelectTestPage';

const StudentVirtualTests = () => {
    return (
        <div className="flex flex-col min-h-screen">
            <Navbar navItems={StudentNavItems} user={STUDENT_USER_TYPE} />

            <div className="flex flex-1 justify-center items-center">
                <StudentSelectTestPage user={STUDENT_USER_TYPE} pathTab={'retake'} />
            </div>

            <Footer user={STUDENT_USER_TYPE} />
        </div>
    )
}

export default StudentVirtualTests;